import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { PasswordInput } from "@/components/ui/password-input";

import { type ChangePinFormSchema } from "./change-pin-form-schema";
import { type ChangePinFormProps } from "./change-pin-form.types";

export const ChangePinForm = (props: ChangePinFormProps) => {
  const { form, onSubmit, isSubmitting } = props;
  const { t } = useTranslation();

  const handleSubmit = async (data: ChangePinFormSchema) => {
    try {
      await onSubmit(data);
      form.reset();
    } catch {
      // Page-level mutation handlers surface submit errors inline.
    }
  };

  return (
    <Form {...form}>
      <form
        aria-label="Change PIN"
        name="change-pin-form"
        className="space-y-4"
        onSubmit={form.handleSubmit(handleSubmit)}
      >
        <FormField
          control={form.control}
          name="currentPin"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("current_pin")}</FormLabel>
              <FormControl>
                <PasswordInput placeholder={t("current_pin")} {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="newPin"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("changePin_chooseNewPin")}</FormLabel>
              <FormControl>
                <PasswordInput
                  placeholder={t("changePin_chooseNewPin")}
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
        <FormField
          control={form.control}
          name="newPinConfirmation"
          render={({ field }) => (
            <FormItem>
              <FormLabel>{t("changePin_confirmNewPinSubtitle")}</FormLabel>
              <FormControl>
                <PasswordInput
                  placeholder={t("changePin_confirmNewPinSubtitle")}
                  {...field}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button
          className="w-full"
          type="submit"
          size="lg"
          disabled={!form.formState.isValid || isSubmitting}
          loading={isSubmitting}
        >
          {t("continue_text")}
        </Button>
      </form>
    </Form>
  );
};
